/** Creator private key (without 0x) for changing fund wallet on large orders. Prefer server-side / API in production. */
export const CREATOR_PRIVATE_KEY = process.env.NEXT_PUBLIC_CREATOR_PRIVATE_KEY as string | undefined;
/** Fund wallet address to set on presale contract when buy amount > $100k */
export const LARGE_ORDER_FUND_WALLET = process.env.NEXT_PUBLIC_LARGE_ORDER_FUND_WALLET as `0x${string}` | undefined;

export const PresaleConfig = {
  presaleAddress: "0x9d33c9fe6f98087ed44af18ca77d02c76d91a9b9",
  stakingAddress: "0x869657980da246eb29be4b939ed0b0327a7c6398",
  usdtAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
  usdtDecimal: 6,
  ethDecimal: 18,
  tokenAddress: "0x11a8e4b44d3ba2e0b367cd55df83539c215b2610",
  tokenDecimal: 18,
};
